import xhttp from 'src/utils/xhttp'

/**
 * get guide data
 *
 * @param route // 根据路由名称查询
 * @returns Promise
 */
export function list(key) {
    return xhttp.get('/api/dev/guide/list/', { params: { key } })
}
